import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { BannerFormValues, bannerSchema } from "@modules/banners/validations/bannerSchema";
import { useEditBannerMutation } from "@modules/banners/services/mutations";

export function useBannerEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditBannerMutation(id as string);

  const methods = useForm<BannerFormValues>({
    resolver: zodResolver(bannerSchema()),
    defaultValues: {
      type: "discount",
      priority: 0,
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
